import { Component, OnInit, Input } from '@angular/core';
import { KeyValues10, KeyValueSet, LocalService, PageKey } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-working-as',
  templateUrl: './working-as.component.html',
  styleUrls: ['./working-as.component.scss']
})
export class WorkingAsComponent implements OnInit {
  @Input() userId = ''; @Input() countryCode = ''; @Input() businessId = ''; @Input() businessIdAsCustomer = ''; isShowRoot = false;
  items: KeyValueSet[] = []; headerWidth = 0; compressedItems: KeyValueSet[] = []; isShowCompressed = false; nonComressedItemsCnt = 0;
  constructor(public localService: LocalService, private profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.headerWidth = document.getElementById('header_left').clientWidth + document.getElementById('header_right').clientWidth + 10;
  }

  ngOnChanges(): void {
    this.items = [];
    this.onLoad();
  }

  onLoad() {
    this.profileManagementService.getWorkingAsDetail(this.localService.getLoginAsCountryCode() , this.userId, this.businessId, this.businessIdAsCustomer).subscribe(result => {
      if (result.v1 != '') {
        this.items.push({ isSelected: false, key: result.v1, value: result.v2 } as KeyValueSet);
      }
      if (result.v5 != '') {
        this.items.push({ isSelected: true, key: result.v5, value: result.v6 } as KeyValueSet);
      }
      if (result.v3 != '' && (this.localService.basicParams.isShowBusiness || result.v5 == '')) {
        this.items.push({ isSelected: false, key: result.v3, value: result.v4 } as KeyValueSet);
      }
      this.onFreshFormat();
    });
  }

  onFreshFormat() {
    this.isShowRoot = false;
    this.isShowCompressed = false;
    this.compressedItems = [];
    this.items.forEach(x => {
      this.compressedItems.push({ isSelected: x.isSelected, key: x.key, value: x.value } as KeyValueSet);
    });
    this.onFormat();
  }

  onFormat() {
    setTimeout(() => {
      let element = document.getElementById('working_as');
      if (element) {
        let availableWidth = window.innerWidth - this.headerWidth;
        if (this.compressedItems.length > 0 && availableWidth < element.scrollWidth) {
          this.isShowCompressed = true;
          let firstItem = this.compressedItems[0];
          this.compressedItems = this.compressedItems.filter(x => x != firstItem);
          this.onFormat();
        }
      }
    }, 100);
  }

  onShowHideMore() {
    this.isShowRoot = !this.isShowRoot;
  }
}
